/* eslint-disable */
const NightRangeObjectValue = Backbone.Model.extend({
	defaults: {
		from: null,
		to: null
	}
});

export default NightRangeObjectValue;